import { useMutation } from '@tanstack/react-query';

import { UploadAnonDataPayload } from '../types';
import { uploadAnonData } from '../services';
import { useSandboxUiContext } from './useSandboxUiContext';

export const useUploadAnonData = () => {
  const sandboxUiContext = useSandboxUiContext();
  const partnerToken = sandboxUiContext?.partnerToken;
  const companyId = sandboxUiContext?.companyId;

  return useMutation({
    mutationFn: async (anonData: UploadAnonDataPayload) => {
      if (!partnerToken) throw new Error('Missing partner token');

      const validatedAnonData = Object.entries(anonData).reduce((accumulator, [key, value]) => {
        if (!value) {
          return accumulator;
        }

        return {
          ...accumulator,
          [key]: value,
        };
      }, {});

      const anonDataWithCompanyId = {
        ...validatedAnonData,
        company_id: companyId,
      } as UploadAnonDataPayload;

      await uploadAnonData(partnerToken, anonDataWithCompanyId);
    },
    onError: async () => {
      if (!partnerToken) throw new Error('Missing partnerToken');
    },
  });
};
